import client from '@/shared/apis/client'

import { type SoapSet, type SoapSetInput } from '../types/masters'

// 定型文の取得と更新。店舗単位・pagination なし (実データで保谷 168 件 / 東綾瀬 231 件。
// 一覧も挿入ダイアログも全件取って手元で絞るため)。

const BASE = '/api/anycompass/soap-sets/'

export const getSoapSets = async (): Promise<SoapSet[]> => {
  const res = await client.get<SoapSet[]>(BASE)
  return res.data ?? []
}

export const createSoapSet = async (input: SoapSetInput): Promise<SoapSet> => {
  const res = await client.post<SoapSet>(BASE, input)
  return res.data
}

export const updateSoapSet = async (
  id: string,
  input: SoapSetInput
): Promise<SoapSet> => {
  const res = await client.put<SoapSet>(`${BASE}${id}/`, input)
  return res.data
}

export const deleteSoapSet = async (id: string): Promise<void> => {
  await client.delete(`${BASE}${id}/`)
}
